import Vue from 'vue'
import Vuex from 'vuex'
Vue.use(Vuex)

export default new Vuex.Store({
	state: {
		toast: {
			bol: false,
			text: ''
		}
	},
	getters: {
		toast: state => {
			return state.toast || ''
		}
	},
	mutations: {
		saveToast(state, value) {
			state.toast = value
			setTimeout(() => {
				state.toast = {
					bol: false,
					text: ''
				}
			}, 1500)
		}
	},
	actions: {
		setToast({ commit }, item) {
			commit('saveToast', item)
		}
	},
	modules: {
	},
	plugins: []
})
